import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
// Must stay above './router': createBrowserRouter reads window.location at import time, so the
// post-login path restore has to happen before that module is evaluated. See the file itself.
import '@/app/bootstrapReturnTo';
// Must ALSO stay above '@/app/router', for a different reason. Vite emits bundled CSS in module
// evaluation order, and the router pulls in every page and therefore every co-located slice sheet.
// Imported below it, this base sheet was emitted LAST and so won every equal-specificity tie
// against the slices — the reverse of what splitting them is for. It cost .footer-brand__mark's
// `margin-left: 0`, which lost to .brand__mark's `margin-left: 8px` and left the footer logo
// sitting 8px right of where the row's own gap puts it.
import '@/app/global.css';
// The MUD primitives, split out of global.css one block per file. Between the base sheet and
// the router for the reason the comment above gives: after global.css, because that is where
// these rules sat in the merged file; before the router, so the slice sheets it pulls in still
// come last and still win their own ties. Their order here is their order in global.css.
import '@/styles/card.css';
import '@/styles/chip.css';
import '@/styles/cover-chip.css';
import '@/styles/tag.css';
import '@/styles/status-tag.css';
import '@/styles/message.css';
import '@/styles/field.css';
import '@/styles/admin-toolbar.css';
import '@/styles/checkbox.css';
import '@/styles/radio.css';
import '@/styles/btn.css';
import '@/styles/empty-state.css';
import '@/styles/page-head.css';
import '@/styles/breadcrumb.css';
import '@/styles/link.css';
import '@/styles/doc-list.css';
import '@/styles/doc-row.css';
import '@/styles/tile-grid.css';
import '@/styles/stat-card.css';
import '@/styles/edit-field.css';
import '@/styles/text-input.css';
import '@/styles/side-drawer.css';
import '@/styles/modal-banner.css';
import '@/styles/event-admin-form.css';
import '@/styles/icon-btn-tooltip.css';
import '@/styles/search-input.css';
import '@/styles/icon-search.css';
import '@/styles/badge.css';
import '@/styles/muted.css';
import '@/styles/confirm-dialog.css';
import '@/styles/modal.css';
import '@/styles/attachment-list.css';
import '@/styles/table.css';
import '@/styles/tile-card.css';
import '@/styles/date-picker.css';
import '@/styles/table-scroll.css';
import '@/styles/required-mark.css';
import { router } from '@/app/router';
import { SessionProvider } from '@/app/session';
import { LanguageProvider } from '@/i18n/LanguageContext';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <LanguageProvider>
      <SessionProvider>
        <RouterProvider router={router} />
      </SessionProvider>
    </LanguageProvider>
  </React.StrictMode>,
);
